module.exports = __webpack_public_path__ + "img/waac.62f50fb2.jpg";